const isServer = () => typeof window === "undefined";

export { isServer };
